import './style/apiConnectionBanner.scss';

import React, {PropsWithChildren} from 'react';

import {onConnectBolOauth} from '../../util/bolOauthUtil';

import {AwesomeIcon} from '@dvrd/dvr-controls';

import classNames from 'classnames';

import Image from '../misc/image';

import {BolmateButton} from '../controls';
import {useTranslation} from 'react-i18next';

interface Props {
    oauthState?: string;
    buttonText?: string;
    title?: string;
    className?: string;
}

export default function APIConnectionBanner(props: PropsWithChildren<Props>) {
    const {t} = useTranslation();
    const {
        oauthState,
        className,
        buttonText = t('apiConnectionBanner.button', 'Nu Bol koppeling vernieuwen'),
        title = t('apiConnectionBanner.title', 'Nieuwe API koppeling vereist'),
        children
    } = props;

    function onClickConnect(evt: React.MouseEvent) {
        onConnectBolOauth(evt.shiftKey, oauthState);
    }

    return (
        <div className={classNames('api-connection-banner', className)}>
            <div className='api-connection-banner-content default-popup'>
                <h3>{title}</h3>
                <Image name='search-ranking' alt='Bolmate' className='connection-image' />
                <div className='banner-content'>{children}</div>
                <BolmateButton
                    onClick={onClickConnect}
                    label={buttonText}
                    ornaments={{element: <AwesomeIcon name='link' />}}
                />
                <span className='explanation'>
                    {t(
                        'apiConnectionBanner.explanation',
                        'Na inloggen bij bol, koppel ons met "retailer" én "adverteerder" zodat wij alle data hebben.'
                    )}
                </span>
            </div>
        </div>
    );
}
